import React, { useMemo } from "react";
import translate from "../../constants/translations";

export interface UploadItem {
	id?: string;
	attachmentId?: string;
	fileName: string;
	fileSize: number;
	percentage: number;
	uploadFailed?: boolean;
	uploadCancelled?: boolean;
	uploadCompleted?: boolean;
}

interface UploadProgressBarProps {
	cultureCode: string;
	upload: UploadItem;
	onClickRemove: () => void;
}

function formatFileSize(fileSize: number): string {
	return fileSize > 1048576
		? `${Math.round((fileSize / 1048576) * 100) / 100} mB`
		: `${Math.round((fileSize / 1024) * 100) / 100} kB`;
}

export default function UploadProgressBar({
	cultureCode,
	upload,
	onClickRemove,
}: UploadProgressBarProps) {
	const formattedFileSize = useMemo(
		() => formatFileSize(upload.fileSize),
		[upload.fileSize],
	);

	const progressStyle = {
		width: `${upload.percentage}%`,
	};

	let className = "mypages-attachment-file-upload";
	if (upload.uploadFailed) {
		className += " mypages-attachment-file-upload--failed";
	}

	return (
		<div data-name="progress-bar" className={className}>
			<div className="mypages-attachment-file-upload__attachment">
				<div className="mypages-attachment-file-upload__file-info">
					<div className="mypages-attachment-file-upload__file-name">
						{upload.fileName}
					</div>
					{upload.uploadFailed && (
						<div className="mypages-attachment-file-upload__status">
							{translate(
								cultureCode,
								"AddingAttachmentsFileUploadErrorMessage",
							)}
						</div>
					)}
					{upload.uploadCancelled && (
						<div className="mypages-attachment-file-upload__status">
							{translate(
								cultureCode,
								"AddingAttachmentsFileUploadCancelledMessage",
							)}
						</div>
					)}
					{upload.uploadCompleted && (
						<div className="mypages-attachment-file-upload__status">
							{translate(
								cultureCode,
								"AddingAttachmentsFileUploadCompletedMessage",
							)}
						</div>
					)}
					<div className="mypages-attachment-file-upload__filesize">
						{formattedFileSize}
					</div>
				</div>
				<div
					className="mypages-attachment-file-upload__progress-bar"
					role="progressbar"
				>
					<div
						className="mypages-attachment-file-upload__progress-value"
						style={progressStyle}
					/>
				</div>
			</div>
			<div className="mypages-attachment-file-upload__remove">
				<button
					type="button"
					data-name="remove-button"
					onClick={onClickRemove}
					className="gb button icon-button icon ui close"
				>
					<span className="gb axe sr-only">Remove</span>
				</button>
			</div>
		</div>
	);
}
